import { render, staticRenderFns } from "./indexAlumnus.vue?vue&type=template&id=715f6eea"
import script from "./indexAlumnus.vue?vue&type=script&lang=js"
export * from "./indexAlumnus.vue?vue&type=script&lang=js"
import style0 from "./indexAlumnus.vue?vue&type=style&index=0&id=715f6eea&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports